<template>
  <div id="medkon-tab">
    <persentase-tren-sentiment-component v-if="data_sentiment && data_sentiment_stats && added_charts.includes(5)"
      :key="data_sentiment_key" :data="data_sentiment" :stats="data_sentiment_stats" />

    <div class="row">
      <div v-if="display_tipe == 1 || display_tipe == 3" class="px-gap mb-4 h-100 col-md-4">
        <top-sources-component title="Media Online" type="3" sentimen="1" :is_disabled="true" />
      </div>

      <div v-if="display_tipe == 1 || display_tipe == 3" class="px-gap mb-4 h-100 col-md-4">
        <top-sources-component title="Media Online" type="3" sentimen="0" :is_disabled="true" />
      </div>

      <div v-if="display_tipe == 1 || display_tipe == 3" class="px-gap mb-4 h-100 col-md-4">
        <top-sources-component title="Media Online" type="3" sentimen="-1" :is_disabled="true" />
      </div>
    </div>
    <!-- tour component -->
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>


<script>
import $ from "jquery";
import persentase_tren_sentiment from "@/views/components/analytics/account-integrity/persentase_tren_sentiment.vue";
import top_sources from "@/views/components/analytics/account-integrity/top_sources.vue";

export default {
  name: "tab_medkon_account_integrity",
  components: {
    "persentase-tren-sentiment-component": persentase_tren_sentiment,
    "top-sources-component": top_sources,
  },
  data() {
    return {
      tour_steps: [],
      filter_tier: "0",

      data_sentiment_key: 40,
      data_sentiment: null,
      data_sentiment_stats: null,

      added_charts: this.$store.getters.user.project.project_detail.charts,

      data_topic_source_key: 90,
      data_topic_source: null,

      data_trend_tier: null,

      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,


      allData: {},
      is_loading: true,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    getData: function () {
      this.is_loading = true;
      var params = this.$route.query;
      params.tier = this.filter_tier;
      if ("items" in params) {
        delete params.items;
      }
      if ("tipe" in params) {
        delete params.tipe;
      }
      if (this.filter_tier == "0") {
        delete params.tier;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (query != "") {
        this.data_sentiment = null;

        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "analytics-formed/" +
          this.id_project +
          "?" +
          query;

        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.data_media_konvensional = {};
              this.data_media_konvensionalBar = {};
              this.allData = response.data;

              this.data_sentiment_stats = [
                {
                  name: "Positif",
                  y: response.data.stats.positif,
                  color: $("body").css("--success") + "AA",
                  source: 'news'
                },
                {
                  name: "Netral",
                  y: response.data.stats.netral,
                  color: "#0e6d87AA",
                  source: 'news'
                },
                {
                  name: "Negatif",
                  y: response.data.stats.negatif,
                  color: $("body").css("--danger") + "AA",
                  source: 'news'
                },
              ];

              this.data_sentiment_stats["name"] = "Berita";

              if ("trend_sentiment_formed" in response.data) {
                this.assembleDataSentiment(
                  response.data.trend_sentiment_formed
                );
              }
            } else {
              this.data_stasiun_tv = {
                table: {},
                grafik: {},
              };
              this.data_program_stasiun_tv = {};
              this.data_jurnalis_media_cetak = {
                table: {},
                grafik: {},
              };
              this.data_media_konvensional = {
                grafik: {},
                stats: {},
              };
              this.data_media_konvensionalBar = {
                categories: {},
                series: {},
              };
            }
          })
          .catch((err) => {
            this.data_stasiun_tv = {
              table: {},
              grafik: {},
            };
            this.data_jurnalis_media_cetak = {
              table: {},
              grafik: {},
            };
            console.log(err);
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
    getTopikSource: function () {
      var params = this.$route.query;
      if ("items" in params) {
        delete params.items;
      }
      if ("tipe" in params) {
        delete params.tipe;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      console.log(query);
      if (query != "") {
        this.data_topic_source = null;
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "charts/bar/topic-source/" +
          this.id_project +
          "?tipe=medkon&" +
          query;
        this.$http.get(api).then((response) => {
          if (response.status == 200) {
            this.data_topic_source = response.data;
            this.data_topic_source.source = 'news';
          } else {
            this.data_topic_source = {};
          }
        });
      }
    },
    assembleDataSentiment: function (dataset) {
      let data = {
        source: 'news',
        x: dataset.date,
        y: [
          {
            name: "Positif",
            data: dataset.positif,
            color: $("body").css("--success"),
          },
          {
            name: "Netral",
            data: dataset.netral,
            color: $("body").css("--info"),
            // visible: false,
          },
          {
            name: "Negatif",
            data: dataset.negatif,
            color: $("body").css("--danger"),
          },
        ],
        yName: "Total",
      };
      this.data_sentiment = data;
      this.data_sentiment_key++;
    },
  },
  mounted: function () {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: ".card-body",
      header: {
        title: "Berpindah Tab",
      },
      content:
        "Anda dapat berpindah tab dengan melakukan klik pada media online atau media sosial.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#grafik-tren",
      header: {
        title: "Tren Media Online",
      },
      content:
        "Menampilkan Grafik Tren dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#tren-group",
      header: {
        title: "Tren Group Topik",
      },
      content:
        "Menampilkan Grafik Tren Group Topik dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#topik-by-source",
      header: {
        title: "Tren Topik Berdasarkan Source",
      },
      content:
        "Menampilkan grafik tren topik berdasarkan sumber dari media online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#grafik-sentimen",
      header: {
        title: "Tren Sentimen",
      },
      content:
        "Menampilkan Grafik dan Persentase Sentimen dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#daftar-topik",
      header: {
        title: "Daftar Topik",
      },
      content:
        "Menampilkan daftar topik dengan jumlah per sentimen dan total data dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#tren-topik",
      header: {
        title: "Tren Topik",
      },
      content:
        "Menampilkan Grafik data tren berdasarkan topik dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#stasiun-tv",
      header: {
        title: "Stasiun TV",
      },
      content:
        "Menampilkan daftar tren stasiun TV dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#grafik-stasiun",
      header: {
        title: "Data Tren Stasiun TV",
      },
      content:
        "Menampilkan grafik tren stasiun TV dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#program-stasiun",
      header: {
        title: "Program Stasiun TV",
      },
      content:
        "Menampilkan grafik jumlah mention untuk setiap program stasiun TV dari Media Online dalam range waktu sesuai dengan filter tanggal..",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[13] = {
      target: "#jurnalis",
      header: {
        title: "Jurnalis",
      },
      content:
        "Menampilkan daftar jurnalis dengan jumlah postingannya dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[14] = {
      target: "#media-cetak",
      header: {
        title: "Media Cetak",
      },
      content:
        "Menampilkan grafik media cetak dengan jumlah per sentimen dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[15] = {
      target: "#emotion",
      header: {
        title: "Emotion",
      },
      content:
        "Menampilkan persentase dan grafik tren emotion dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
  watch: {
    $route() {
      this.getData();
      this.getTopikSource();
    },
  },
  created: function () {
    this.getData();
    this.getTopikSource();
  },
};
</script>